import React from 'react'
import Banner from '../../components/UserSideComponents/blogdetails/Banner'
import BlogImage from '../../components/UserSideComponents/blogdetails/BlogImage'
import Internship from '../../components/UserSideComponents/blogdetails/Internship'
function BlogDetails() {
  return (
    <div>
      <Banner/>
      <BlogImage/>
      <Internship/>
    </div>
  )
}

export default BlogDetails
